// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ce5207dd","667":"51f49d86"}[chunkId] + ".chunk.js";
};